import { render, staticRenderFns } from "./PlanOfferItem.vue?vue&type=template&id=507cfa72&scoped=true&"
import script from "./PlanOfferItem.vue?vue&type=script&lang=js&"
export * from "./PlanOfferItem.vue?vue&type=script&lang=js&"
import style0 from "./PlanOfferItem.vue?vue&type=style&index=0&id=507cfa72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cfa72",
  null
  
)

export default component.exports